import React from "react";
import styles from "./DvdFond.module.css";
import {resoudre} from "../reglages";
import {REGLAGES} from "./reglages";
import {durees, imagesClesCouleur} from "./rebonds";

/*
 * Fond « Logo DVD » : un logo qui traverse le bandeau en rebondissant sur les bords, et change de couleur à chaque rebond,
 * comme l'écran de veille des lecteurs DVD. Le logo d'origine est un dessin ORIGINAL dans cet esprit (texte et disque en SVG),
 * pas le logo officiel (marque déposée). Il peut être remplacé par une image de la galerie (propriété `images`, la première).
 * Le logo avance à vitesse constante dans les deux sens (deux déplacements transform imbriqués, un par axe) ; les durées et les
 * couleurs viennent de rebonds.js (testé). Réglages (reglages.js) : vitesse, taille du logo, changement de couleur.
 */

const RAPPORT_DVD = 2.1;     // largeur / hauteur du dessin d'origine (viewBox 210 × 100)

const LogoDvd = () => (
    <svg viewBox="0 0 210 100" width="100%" height="100%" aria-hidden="true">
        <text x="105" y="66" textAnchor="middle" fontFamily='"Arial Black", Impact, Arial, sans-serif' fontStyle="italic" fontWeight="900"
              fontSize="74" fill="#ff2a2a" textLength="204" lengthAdjust="spacingAndGlyphs">DVD</text>
        <ellipse cx="105" cy="85" rx="100" ry="13" fill="none" stroke="#ff2a2a" strokeWidth="6"/>
        <ellipse cx="105" cy="85" rx="22" ry="5" fill="#ff2a2a"/>
    </svg>
);

export default function DvdFond({reglages, images = []}) {
    const {vitesse, taille, couleur} = resoudre(REGLAGES, reglages);
    const adresse = images[0];
    // rapport largeur / hauteur de l'image de la galerie, connu une fois chargée ; en attendant (ou si elle échoue) : le logo d'origine
    const [lue, setLue] = React.useState(null);
    const etat = adresse && lue && lue.adresse === adresse ? lue : null;
    const image = etat && !etat.hs ? adresse : null;
    const rapport = image ? etat.rapport : RAPPORT_DVD;

    const h = taille, w = Math.round(h * rapport);
    const {tx, ty, n} = durees(vitesse, w, h);
    const nomCouleur = `dvdCouleur${n}`;

    return (
        <div className={styles.scene} aria-hidden="true">
            {couleur && <style>{imagesClesCouleur(nomCouleur, n)}</style>}
            <div className={styles.x} style={{width: `calc(100% - ${w}px)`, animationDuration: `${tx.toFixed(3)}s`}}>
                <div className={styles.y} style={{width: w, height: `calc(100% - ${h}px)`, animationDuration: `${ty.toFixed(3)}s`}}>
                    <div
                        className={styles.logo}
                        style={couleur ? {
                            width: w,
                            height: h,
                            animationName: nomCouleur,
                            animationDuration: `${(2 * tx).toFixed(3)}s`,
                            animationTimingFunction: "step-end",
                            animationIterationCount: "infinite",
                        } : {width: w, height: h}}
                    >
                        {image ? <img src={image} alt="" className={styles.image}/> : <LogoDvd/>}
                    </div>
                </div>
            </div>
            {adresse && (!etat || image) && (
                <img
                    src={adresse}
                    alt=""
                    style={{display: "none"}}
                    onLoad={ev => setLue({adresse, rapport: ev.target.naturalHeight ? ev.target.naturalWidth / ev.target.naturalHeight : RAPPORT_DVD})}
                    onError={() => setLue({adresse, hs: true})}
                />
            )}
        </div>
    );
}
